// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nQ","cardInnerHeading":"nR","toggleWrapperClass":"nS","changeProfile":"nT nS","textWrapperClass":"nU","toggleTextClass":"nV"};